<template>
  <v-chart :option="option" class="mt--5" :autoresize="true" />
</template>

<script>
import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { PieChart, GaugeChart } from "echarts/charts";
import {
  TitleComponent,
  TooltipComponent,
  LegendComponent
} from "echarts/components";
import VChart, { THEME_KEY } from "vue-echarts";

use([
  CanvasRenderer,
  PieChart,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GaugeChart
]);

export default {
  name: "HelloWorld",
  components: {
    VChart
  },
  provide: {
    [THEME_KEY]: "light"
  },
  props: {
    score: {
      type: Number,
      default: () => 0
    },
    maxValue: {
      type: Number,
      default: () => 100
    }
  },
  computed: {
    option() {
      return {
        series: [
          {
            type: 'gauge',
            startAngle: 180,
            endAngle: 0,
            min: 0,
            max: 1,
            splitNumber: 8,
            axisLine: {
              lineStyle: {
                width: 6,
                color: [
                  [0.25, '#f5365c'],
                  [0.5, '#FDDD60'],
                  [0.75, '#11cdef'],
                  [1, '#2dce89']
                ]
              }
            },
            pointer: {
              icon: 'path://M12.8,0.7l12,40.1H0.7L12.8,0.7z',
              length: '12%',
              width: 20,
              offsetCenter: [0, '-60%'],
              itemStyle: {
                color: 'auto'
              }
            },
            axisTick: {
              length: 12,
              lineStyle: {
                color: 'auto',
                width: 2
              }
            },
            splitLine: {
              length: 20,
              lineStyle: {
                color: 'auto',
                width: 5
              }
            },
            axisLabel: {
              color: '#464646',
              fontSize: 10,
              distance: -60,
              formatter: function (value) {
                if (value === 0.875) {
                  return '';
                } else if (value === 0.625) {
                  return '';
                } else if (value === 0.375) {
                  return '';
                } else if (value === 0.125) {
                  return '';
                }
                return '';
              }
            },
            title: {
              offsetCenter: [0, '-30%'],
              fontSize: 30,
            },
            detail: {
              fontSize: 35,
              top: '30%',
              offsetCenter: [0, '0%'],
              valueAnimation: true,
              color: 'auto'
            },
            data: [
              {
                value: this.score / this.maxValue || 0,
                detail: {
                  formatter: (param) => this.score.toLocaleString('pt-BR'),
                },
                name: 'Score'
              }
            ]
          }
        ]
      }
    },
  }
};
</script>
